"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useProductListOrderMap;

var _react = _interopRequireDefault(require("react"));

var _usePreferredLocale = _interopRequireDefault(require("@sprinx/react-globalize/usePreferredLocale"));

var _useShoppingCurrency = _interopRequireDefault(require("../../../shop/useShoppingCurrency"));

var _useShoppingStockOrderingGroup = _interopRequireDefault(require("../../../shop/useShoppingStockOrderingGroup"));

function useProductListOrderMap() {
  var currency = (0, _useShoppingCurrency.default)();
  var locale = (0, _usePreferredLocale.default)();
  var stockOrderingGroup = (0, _useShoppingStockOrderingGroup.default)();
  return _react.default.useMemo(function () {
    var nameField = "name.".concat(locale);
    var priceField = "_pricing._default.price.".concat(currency);
    return {
      default: {
        orderBy: "_ordering.".concat(stockOrderingGroup, ",-_pricing._default.price.").concat(currency)
      },
      nameAsc: {
        orderBy: nameField,
        orderDirection: 'asc'
      },
      nameDesc: {
        orderBy: nameField,
        orderDirection: 'desc'
      },
      listPriceAsc: {
        orderBy: priceField,
        orderDirection: 'asc'
      },
      listPriceDesc: {
        orderBy: priceField,
        orderDirection: 'desc'
      }
    };
  }, [currency, locale, stockOrderingGroup]);
}